import { EQuestionDifficulty, EQuizMode } from '@constants';

export const CommonQuizFormTranslations = {
  VALIDATE_QUIZ_TOOLTIP: {
    es: 'Detecta posibles errores y genera explicaciones automáticas.',
    en: 'Detects possible errors and generates automatic explanations.',
    cat: 'Detecta possibles errors i genera explicacions automàtiques.',
    eus: 'Ezin esan daitezke emaitza eta ebazpenak automatikoki sortu.',
    pt: 'Detecta possíveis erros e gera explicações automáticas.'
  },
  REVIEW: {
    es: 'Revisar',
    en: 'Review',
    cat: 'Revisar',
    eus: 'Egiaztatu',
    pt: 'Revisar'
  },
  NOT_VALIDATED: {
    es: 'No validado',
    en: 'Not validated',
    cat: 'No validat',
    eus: 'Ez da egiaztatu',
    pt: 'Não validado'
  },
  SAVE_DRAFT: {
    es: 'Guardar borrador',
    en: 'Save draft',
    cat: 'Guardar borrador',
    eus: 'Gorde zirriborroa',
    pt: 'Guardar rascunho'
  },
  PUBLISH: {
    es: 'Publicar',
    en: 'Publish',
    cat: 'Publicar',
    eus: 'Erantzun',
    pt: 'Publicar'
  },
  REVIEW_BEFORE_PUBLISHING: {
    es: 'Revisa el test antes de publicarlo',
    en: 'Review the test before publishing it',
    cat: 'Revisa el test abans de publicar-lo',
    eus: 'Egiaztatu testua argitaratzeko',
    pt: 'Revise o teste antes de publicá-lo'
  },
  N_QUESTIONS: {
    es: '{{count}} preguntas',
    en: '{{count}} questions',
    cat: '{{count}} preguntes',
    eus: '{{count}} galderak',
    pt: '{{count}} questões'
  },
  [EQuizMode.QUIZ]: {
    es: '🎯 Quiz',
    en: '🎯 Quiz',
    cat: '🎯 Quiz',
    eus: '🎯 Quiz',
    pt: '🎯 Quiz'
  },
  [EQuizMode.PRACTICE]: {
    es: '⏳ Simulacro',
    en: '⏳ Simulator',
    cat: '⏳ Simulacre',
    eus: '⏳ Simulazio',
    pt: '⏳ Simulador'
  },
  [EQuizMode.TRUE_FALSE]: {
    es: '🏓 Verdadero o Falso',
    en: '🏓 True or False',
    cat: '🏓 Veritat o Fals',
    eus: '🏓 Egia edo Derrus',
    pt: '🏓 Verdadeiro ou Falso'
  },
  [EQuizMode.PRACTICAL_CASE]: {
    es: '📋 Caso Práctico',
    en: '📋 Practical Case',
    cat: '📋 Cas Pràctic',
    eus: '📋 Praktike kasua',
    pt: '📋 Caso Prático'
  },
  [EQuizMode.LIGHTNING]: {
    es: '⚡️ Relámpago',
    en: '⚡️ Lightning',
    cat: '⚡️ Llampada',
    eus: '⚡️ Ikasti',
    pt: '⚡️ Relâmpago'
  },
  ADD_QUESTION: {
    es: 'Añadir pregunta',
    en: 'Add question',
    cat: 'Afegir pregunta',
    eus: 'Galdera bat gehitu',
    pt: 'Adicionar questão'
  },
  ADD_FROM_LIST: {
    es: 'Añadir del listado',
    en: 'Add from list',
    cat: 'Afegir del llistat',
    eus: 'Zerrendatik gehitu',
    pt: 'Adicionar da lista'
  },
  QUESTION_NUMBER: {
    es: 'Pregunta {{number}}',
    en: 'Question {{number}}',
    cat: 'Pregunta {{number}}',
    eus: 'Galdera {{number}}',
    pt: 'Questão {{number}}'
  },
  QUESTION: {
    es: 'Pregunta',
    en: 'Question',
    cat: 'Pregunta',
    eus: 'Galdera',
    pt: 'Questão'
  },
  ANSWERS: {
    es: 'Respuestas',
    en: 'Answers',
    cat: 'Respostes',
    eus: 'Erantzunak',
    pt: 'Respostas'
  },
  WRITE_THE_QUESTION: {
    es: 'Escribe la pregunta...',
    en: 'Write the question...',
    cat: 'Escriu la pregunta...',
    eus: 'Galdera idatzi...',
    pt: 'Escreva a pergunta...'
  },
  ADD_IMAGE: {
    es: 'Añadir imagen',
    en: 'Add image',
    cat: 'Afegir imatge',
    eus: 'Irudia gehitu',
    pt: 'Adicionar imagem'
  },
  ADD_FORMULA: {
    es: 'Añadir fórmula',
    en: 'Add formula',
    cat: 'Afegir fórmula',
    eus: 'Formula gehitu',
    pt: 'Adicionar fórmula'
  },
  HIDE_QUESTION: {
    es: 'Ocultar',
    en: 'Hide',
    cat: 'Ocultar',
    eus: 'Ezabatu',
    pt: 'Ocultar'
  },
  DUPLICATE_QUESTION: {
    es: 'Duplicar',
    en: 'Duplicate',
    cat: 'Duplicar',
    eus: 'Kopiatu',
    pt: 'Duplicar'
  },
  DELETE_QUESTION: {
    es: 'Eliminar pregunta',
    en: 'Delete question',
    cat: 'Eliminar pregunta',
    eus: 'Galdera ezabatu',
    pt: 'Eliminar questão'
  },
  ARE_YOU_SURE_TO_DELETE_ANSWER: {
    es: '¿Estás seguro de querer eliminar esta respuesta?',
    en: 'Are you sure you want to delete this answer?',
    cat: 'Estàs segur de voler eliminar aquesta resposta?',
    eus: 'Ziur zaude erantzun hau ezabatu nahi duzula?',
    pt: 'Tens a certeza de que queres eliminar esta resposta?'
  },
  ADD_NEW_EMPTY_ANSWER: {
    es: 'Añadir nueva respuesta',
    en: 'Add new answer',
    cat: 'Afegir nova resposta',
    eus: 'Erantzun berria gehitu',
    pt: 'Adicionar nova resposta'
  },
  ANSWERS_SUBTITLE_MULTIPLE_CHOICE: {
    es: 'Añade cuatro opciones de respuesta y selecciona la correcta.',
    en: 'Add four options of answer and select the correct one.',
    cat: 'Afegeix quatre opcions de resposta i selecciona la correcta.',
    eus: 'Erantzun zuzena hautatu',
    pt: 'Selecione a resposta correta'
  },
  ANSWERS_SUBTITLE_TRUE_FALSE: {
    es: 'Indica si la afirmación es verdadera o falsa.',
    en: 'Indicate if the statement is true or false.',
    cat: 'Indica si la afirmació és certa o falsa.',
    eus: 'Erantzun zuzena hautatu',
    pt: 'Selecione a resposta correta'
  },
  WRITE_HERE_THE_ANSWER: {
    es: 'Escribe la respuesta...',
    en: 'Write the answer...',
    cat: 'Escriu la resposta...',
    eus: 'Erantzun idatzi...',
    pt: 'Escreva a resposta...'
  },
  DELETE_ANSWER: {
    es: 'Eliminar respuesta',
    en: 'Delete answer',
    cat: 'Eliminar resposta',
    eus: 'Erantzun ezabatu',
    pt: 'Eliminar resposta'
  },
  ADD_ANSWER: {
    es: 'Añadir respuesta',
    en: 'Add answer',
    cat: 'Afegir resposta',
    eus: 'Erantzun gehitu',
    pt: 'Adicionar resposta'
  },
  EXPLANATION: {
    es: 'Explicación',
    en: 'Explanation',
    cat: 'Explicació',
    eus: 'Erantzun',
    pt: 'Explicação'
  },
  EXPLANATION_SUBTITLE: {
    es: 'Incluye una explicación para justificar la respuesta correcta. Si no la añades, se generará una explicación automática en la revisión.',
    en: 'Include an explanation to justify the correct answer. If you do not add it, an automatic explanation will be generated in the review.',
    cat: "Inclou una explicació per justificar la resposta correcta. Si no l'añades, es generarà una explicació automàtica en la revisió.",
    eus: 'Erantzun zuzena justifikatzeko azalpen bat gehitu. Ez baduzke bereiztu, azalpena automatikoki sortuko da betetik.',
    pt: 'Inclua uma explicação para justificar a resposta correta. Se não adicionar, uma explicação automática será gerada na revisão.'
  },
  WRITE_HERE: {
    es: 'Escribe aquí...',
    en: 'Write here...',
    cat: 'Escriu aquí...',
    eus: 'Idatzi hemen...',
    pt: 'Escreva aqui...'
  },
  PENDING_VALIDATION_COUNT_one: {
    es: '{{count}} pregunta no revisada',
    en: '{{count}} question not reviewed',
    cat: '{{count}} pregunta no revisada',
    eus: '{{count}} galdera ez da egiaztatu',
    pt: '{{count}} questão não revisada'
  },
  PENDING_VALIDATION_COUNT_other: {
    es: '{{count}} preguntas no revisadas',
    en: '{{count}} questions not reviewed',
    cat: '{{count}} preguntes no revisades',
    eus: '{{count}} galderak ez dira egiaztatu',
    pt: '{{count}} questões não revisadas'
  },
  PENDING_VALIDATION_COUNT_DESCRIPTION: {
    es: 'Revisa el test con IA para detectar posibles errores y completar las explicaciones vacías.',
    en: 'Review the test with AI to detect possible errors and complete the empty explanations.',
    cat: 'Revisa el test amb IA per detectar possibles errors i completar les explicacions buides.',
    eus: 'Egiaztatu testua IA erabiliz, posibleak gertatu diren erroreak aurkitu eta hutsak betetu.',
    pt: 'Revise o teste com IA para detectar possíveis erros e completar as explicações vazias.'
  },
  EDIT: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  VIEW: {
    es: 'Ver',
    en: 'View',
    cat: 'Ver',
    eus: 'Ikusi',
    pt: 'Ver'
  },
  REVIEWING: {
    es: 'Revisando...',
    en: 'Reviewing...',
    cat: 'Revisant...',
    eus: 'Egiaztatzen...',
    pt: 'Revisando...'
  },
  VALIDATED: {
    es: 'Validado',
    en: 'Validated',
    cat: 'Validat',
    eus: 'Egiaztatu',
    pt: 'Validado'
  },
  INVALID_QUESTIONS_COUNT_one: {
    es: '{{count}} pregunta rechazada',
    en: '{{count}} question rejected',
    cat: '{{count}} pregunta rebutjada',
    eus: '{{count}} galdera ezezagun',
    pt: '{{count}} questão rejeitada'
  },
  INVALID_QUESTIONS_COUNT_other: {
    es: '{{count}} preguntas rechazadas',
    en: '{{count}} questions rejected',
    cat: '{{count}} preguntes rebutjades',
    eus: '{{count}} galderak ezezagun',
    pt: '{{count}} questões rejeitadas'
  },
  INVALID_QUESTIONS_COUNT_DESCRIPTION: {
    es: 'Corrígelas o elimínalas para publicar el test.',
    en: 'Correct them or delete them to publish the test.',
    cat: 'Corregis-les o elimina-les per publicar el test.',
    eus: 'Ezabatu edo ebatzi egin daitezke testua argitaratzeko.',
    pt: 'Corrija-as ou elimine-as para publicar o teste.'
  },
  NOT_REVIEWED: {
    es: 'No revisada',
    en: 'Not reviewed',
    cat: 'No revisada',
    eus: 'Ez da egiaztatu',
    pt: 'Não revisada'
  },
  REJECTED: {
    es: 'Rechazada',
    en: 'Rejected',
    cat: 'Rebutjada',
    eus: 'Ezezagun',
    pt: 'Rejeitada'
  },
  VALIDATED_STATUS: {
    es: 'Validada',
    en: 'Validated',
    cat: 'Validada',
    eus: 'Egiaztatu',
    pt: 'Validada'
  },
  WHY_IS_THIS_QUESTION_REJECTED: {
    es: '¿Por qué ha sido rechazada?',
    en: 'Why has this question been rejected?',
    cat: '¿Per què ha sigut rebutjada?',
    eus: 'Zer moduz ezezagun',
    pt: 'Por que esta questão foi rejeitada?'
  },
  THIS_QUESTION_IS_VALID: {
    es: 'La pregunta está bien',
    en: 'The question is valid',
    cat: 'La pregunta està bé',
    eus: 'Galdera zuzena da',
    pt: 'A questão está bem'
  },
  IS_THE_QUESTION_OK: {
    es: '¿La pregunta está bien?',
    en: 'Is the question ok?',
    cat: 'Està bé la pregunta?',
    eus: 'Galdera zuzena da',
    pt: 'A questão está bem'
  },
  VALIDATION_CONFIRMATION_DESCRIPTION: {
    es: 'La IA puede cometer fallos al corregir. Revisa la pregunta y las respuestas con atención. Si crees que todo está bien, valídala.',
    en: 'The AI may make mistakes when correcting. Review the question and answers carefully. If you believe everything is fine, validate it.',
    cat: 'La IA pot cometre errors al corregir. Revisa la pregunta i les respostes amb atenció. Si creus que tot està bé, valida-la.',
    eus: 'IA ezin duzu emaitza ebatzi. Galdera eta emaitzak berriro begiratu. Emaitza zuzena da, egiaztatu.',
    pt: 'A IA pode cometer erros ao corrigir. Revise a pergunta e as respostas com atenção. Se acredita que tudo está bem, valide-a.'
  },
  VALIDATE_QUESTION: {
    es: 'Validar pregunta',
    en: 'Validate question',
    cat: 'Validar pregunta',
    eus: 'Egiaztatu galdera',
    pt: 'Validar questão'
  },
  FILL_ALL_QUESTIONS_TO_VALIDATE: {
    es: 'Rellena todas las preguntas para validar el test',
    en: 'Fill in all questions to validate the test',
    cat: 'Rellena totes les preguntes per validar el test',
    eus: 'Ebatzi guztira galderak, testua egiaztatzeko',
    pt: 'Complete todas as questões para validar o teste'
  },
  FILL_ALL_FIELDS: {
    es: 'Rellena todos los campos',
    en: 'Fill in all fields',
    cat: 'Rellena tots els camps',
    eus: 'Ebatzi guztira eremuak',
    pt: 'Complete todos os campos'
  },
  WRITE_THE_EXPLANATION_YOURSELF: {
    es: 'Si crees que la pregunta está bien, escribe la explicación tu mismo.',
    en: 'If you believe the question is ok, write the explanation yourself.',
    cat: "Si creus que la pregunta està bé, escriu l'explicació tu mateix.",
    eus: 'Erantzun zuzena da, azalpena idatzi zuretzat.',
    pt: 'Se acredita que a pergunta está bem, escreva a explicação por si mesmo.'
  },
  VALIDATE_NOW: {
    es: 'Validar ahora',
    en: 'Validate now',
    cat: 'Validar ara',
    eus: 'Egiaztatu ora',
    pt: 'Validar agora'
  },
  INSERT_FORMULA: {
    es: 'Insertar fórmula',
    en: 'Insert formula',
    cat: 'Inserir fórmula',
    eus: 'Formula gehitu',
    pt: 'Inserir fórmula'
  },
  QUESTION_CREATED: {
    es: 'Pregunta creada correctamente',
    en: 'Question created successfully',
    cat: 'Pregunta creada correctament',
    eus: 'Galdera ongi sortu da',
    pt: 'Questão criada com sucesso'
  },
  QUESTION_UPDATED: {
    es: 'Pregunta actualizada correctamente',
    en: 'Question updated successfully',
    cat: 'Pregunta actualitzada correctament',
    eus: 'Galdera ongi eguneratu da',
    pt: 'Questão atualizada com sucesso'
  },
  DELETE_QUESTION_SUCCESS: {
    es: 'Pregunta eliminada correctamente',
    en: 'Question deleted successfully',
    cat: 'Pregunta eliminada correctament',
    eus: 'Galdera ongi ezabatu da',
    pt: 'Questão eliminada com sucesso'
  },
  DELETE_QUESTIONS_SUCCESS: {
    es: 'Preguntas eliminadas correctamente',
    en: 'Questions deleted successfully',
    cat: 'Preguntes eliminades correctament',
    eus: 'Galderak ongi ezabatu dira',
    pt: 'Questões eliminadas com sucesso'
  },
  QUIZZES_CONTAINING_QUESTION: {
    es: 'Tests que contienen esta pregunta',
    en: 'Quizzes containing this question',
    cat: 'Tests que contenen aquesta pregunta',
    eus: 'Testuak hori daukat galdera',
    pt: 'Testes que contêm esta pergunta'
  },
  UPDATE_QUESTION: {
    es: 'Actualizar pregunta',
    en: 'Update question',
    cat: 'Actualitzar pregunta',
    eus: 'Eguneratu galdera',
    pt: 'Atualizar questão'
  },
  UPDATE_QUESTION_WARNING: {
    es: 'Si actualizas esta pregunta, se aplicará a todos los tests que la contienen.',
    en: 'If you update this question, it will be applied to all quizzes that contain it.',
    cat: 'Si actualitzes aquesta pregunta, es aplicarà a tots els tests que la contenen.',
    eus: 'Eguneratu galdera, testu guztiak daukat hori.',
    pt: 'Se atualizar esta pergunta, será aplicada a todos os testes que a contêm.'
  },
  SELECT_IMAGE: {
    es: 'Seleccionar imagen',
    en: 'Select image',
    cat: 'Seleccionar imatge',
    eus: 'Irudia hautatu',
    pt: 'Selecionar imagem'
  },
  YEAR: {
    es: 'Año',
    en: 'Year',
    cat: 'Any',
    eus: 'Urtea',
    pt: 'Ano'
  },
  DIFFICULTY: {
    es: 'Dificultad',
    en: 'Difficulty',
    cat: 'Dificultat',
    eus: 'Zailtasuna',
    pt: 'Dificuldade'
  },
  [EQuestionDifficulty.EASY]: {
    es: 'Fácil',
    en: 'Easy',
    cat: 'Fàcil',
    eus: 'Oso erraza',
    pt: 'Fácil'
  },
  [EQuestionDifficulty.MEDIUM]: {
    es: 'Media',
    en: 'Medium',
    cat: 'Mitja',
    eus: 'Ertaina',
    pt: 'Média'
  },
  [EQuestionDifficulty.HARD]: {
    es: 'Difícil',
    en: 'Hard',
    cat: 'Difícil',
    eus: 'Oso zaila',
    pt: 'Difícil'
  },
  EXPLANATION_TOOLTIP: {
    es: 'Incluye una explicación para justificar la respuesta correcta. Si no la añades, se generará una explicación automática en la revisión.',
    en: 'Include an explanation to justify the correct answer. If you do not add it, an automatic explanation will be generated in the review.',
    cat: "Inclou una explicació per justificar la resposta correcta. Si no l'añades, es generarà una explicació automàtica en la revisió.",
    eus: 'Erantzun zuzena justifikatzeko azalpen bat gehitu. Ez baduzke bereiztu, azalpena automatikoki sortuko da betetik.',
    pt: 'Inclua uma explicação para justificar a resposta correta. Se não adicionar, uma explicação automática será gerada na revisão.'
  },
  EXAM_DURATION: {
    es: 'Duración del examen',
    en: 'Exam duration',
    cat: "Duració de l'examen",
    eus: 'Ikaslearen emaitza',
    pt: 'Duração do exame'
  },
  HOURS: {
    es: 'Horas',
    en: 'Hours',
    cat: 'Horas',
    eus: 'Orduak',
    pt: 'Horas'
  },
  MINUTES: {
    es: 'Minutos',
    en: 'Minutes',
    cat: 'Minuts',
    eus: 'Minutuak',
    pt: 'Minutos'
  },
  QUIZ_TITLE_FOR_MODE: {
    es: 'Nombre del {{mode}}',
    en: '{{mode}} name',
    cat: 'Nom del {{mode}}',
    eus: '{{mode}} izena',
    pt: 'Nome do {{mode}}'
  },
  QUIZ_TITLE_PLACEHOLDER: {
    es: 'Funciones exponenciales II',
    en: 'Exponential functions II',
    cat: 'Funcións exponencials II',
    eus: 'Exponenziagarri funtzioak II',
    pt: 'Funções exponenciais II'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikastola',
    pt: 'Curso'
  },
  SECTION: {
    es: 'Unidad',
    en: 'Section',
    cat: 'Unitat',
    eus: 'Gaia',
    pt: 'Unidade'
  },
  CONFIGURATION: {
    es: 'Configuración',
    en: 'Configuration',
    cat: 'Configuració',
    eus: 'Konfigurazioa',
    pt: 'Configuração'
  },
  SAVE: {
    es: 'Guardar',
    en: 'Save',
    cat: 'Guardar',
    eus: 'Gorde',
    pt: 'Guardar'
  },
  DELETE_QUIZ: {
    es: 'Eliminar test',
    en: 'Delete quiz',
    cat: 'Eliminar test',
    eus: 'Ezabatu testua',
    pt: 'Eliminar teste'
  },
  DUPLICATE_QUIZ: {
    es: 'Duplicar test',
    en: 'Duplicate quiz',
    cat: 'Duplicar test',
    eus: 'Kopiatu testua',
    pt: 'Duplicar teste'
  },
  DELETE_QUIZ_CONFIRMATION: {
    es: '¿Estás seguro de que quieres eliminar este test?',
    en: 'Are you sure you want to delete this quiz?',
    cat: 'Estàs segur de voler eliminar aquest test?',
    eus: 'Ziur proba hau ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar este teste?'
  },
  EXISTING_QUESTION_WARNING: {
    es: 'Los cambios que hagas se replicarán en todos los test que tengan esta pregunta.',
    en: 'The changes you make will be replicated in all quizzes that have this question.',
    cat: 'Els canvis que faci es replicaran en tots els tests que tinguin aquesta pregunta.',
    eus: 'Eguneratu galdera, testu guztiak daukat hori.',
    pt: 'Os cambios que fizer se replicarão em todos os testes que tenham esta pergunta.'
  },
  VIEW_QUIZZES: {
    es: 'Ver tests',
    en: 'View quizzes',
    cat: 'Veure tests',
    eus: 'Ikusi testuak',
    pt: 'Ver testes'
  },
  QUESTION_IN_QUIZZES_one: {
    es: 'Esta pregunta aparece en {{count}} test:',
    en: 'This question appears in {{count}} quiz:',
    cat: 'Aquesta pregunta apareix en {{count}} test:',
    eus: 'Galdera hau {{count}} testutan agertzen da:',
    pt: 'Esta pergunta aparece em {{count}} teste:'
  },
  QUESTION_IN_QUIZZES_other: {
    es: 'Esta pregunta aparece en {{count}} tests:',
    en: 'This question appears in {{count}} quizzes:',
    cat: 'Aquesta pregunta apareix en {{count}} tests:',
    eus: 'Galdera hau {{count}} testutan agertzen da:',
    pt: 'Esta pergunta aparece em {{count}} testes:'
  },
  QUIZ_READY_TO_PUBLISH: {
    es: '¡Test validado y listo para publicar!',
    en: 'Quiz validated and ready to publish!',
    cat: 'Test validat i llest per publicar!',
    eus: 'Testua egiaztatu eta argitaratzeko prest',
    pt: 'Teste validado e pronto para publicar!'
  },
  SEARCH_QUESTIONS: {
    es: 'Buscar preguntas',
    en: 'Search questions',
    cat: 'Cercar preguntes',
    eus: 'Galdera bilatu',
    pt: 'Pesquisar questões'
  },
  SELECT_QUESTIONS_TO_ADD: {
    es: 'Selecciona las preguntas que quieras añadir al test.',
    en: 'Select the questions you want to add to the quiz.',
    cat: 'Selecciona les preguntes que vols afegir al test.',
    eus: 'Galderak gehitu nahi duzun testuan.',
    pt: 'Selecione as questões que deseja adicionar ao teste.'
  },
  ADD: {
    es: 'Añadir',
    en: 'Add',
    cat: 'Afegir',
    eus: 'Gehitu',
    pt: 'Adicionar'
  },
  SELECTED_QUESTIONS_COUNT: {
    es: '<a>{{count}} preguntas</a> seleccionadas',
    en: '<a>{{count}} questions</a> selected',
    cat: '<a>{{count}} preguntes</a> seleccionades',
    eus: '<a>{{count}} galderak</a> hautatu',
    pt: '<a>{{count}} questões</a> selecionadas'
  },
  ADD_FROM_LIST_TOOLTIP: {
    es: 'Añade preguntas ya creadas',
    en: 'Add questions already created',
    cat: 'Afegeix preguntes ja creades',
    eus: 'Galderak ezagutu eta gehitu',
    pt: 'Adicione questões já criadas'
  },
  TRUE: {
    es: 'Verdadero',
    en: 'True',
    cat: 'Veritat',
    eus: 'Egia',
    pt: 'Verdadeiro'
  },
  FALSE: {
    es: 'Falso',
    en: 'False',
    cat: 'Fals',
    eus: 'Gezurra',
    pt: 'Falso'
  },
  PRACTICAL_CASE_TITLE: {
    es: 'Caso práctico',
    en: 'Practical case',
    cat: 'Cas pràctic',
    eus: 'Eskubide praktikoa',
    pt: 'Caso prático'
  },
  WRITE_THE_PRACTICAL_CASE: {
    es: 'Escribe el caso práctico',
    en: 'Write the practical case',
    cat: 'Escriu el cas pràctic',
    eus: 'Eskubide praktikoa idatzi',
    pt: 'Escreva o caso prático'
  },
  WRITE_PRACTICAL_CASE_DESCRIPTION: {
    es: 'Incluye la información necesaria para que los alumnos puedan analizar el caso y responder las preguntas.',
    en: 'Include the necessary information so that students can analyze the case and answer the questions.',
    cat: 'Inclou la informació necessària perquè els alumnes puguin analitzar el cas i respondre les preguntes.',
    eus: 'Eskubide praktikoaren ezagutu behar duzun.',
    pt: 'Inclua as informações necessárias para que os alunos possam analisar o caso e responder às perguntas.'
  },
  SHOW_QUESTION: {
    es: 'Mostrar pregunta',
    en: 'Show question',
    cat: 'Mostrar pregunta',
    eus: 'Galdera erakutsi',
    pt: 'Mostrar questão'
  },
  HIDDEN_QUESTION_WARNING: {
    es: 'Esta pregunta está oculta para los alumnos',
    en: 'This question is hidden from students',
    cat: 'Aquesta pregunta està oculta als alumnes',
    eus: 'Galdera ikusi ezin daiteke',
    pt: 'Esta questão está oculta para os alunos'
  },
  DOWNLOAD_QUIZ: {
    es: 'Descargar',
    en: 'Download',
    cat: 'Descarregar',
    eus: 'Eskubide deskargatu',
    pt: 'Descarregar'
  },

  TEMPLATE_CSV_DOWNLOADED: {
    es: 'CSV descargado correctamente',
    en: 'CSV downloaded successfully',
    cat: 'CSV descarregat correctament',
    eus: 'Eskubide CSV deskargatu da',
    pt: 'CSV descarregado com sucesso'
  },
  DELETE_QUIZ_MODAL_TITLE: {
    es: 'Este test está en uso',
    en: 'This quiz is in use',
    cat: 'Aquest test està en ús',
    eus: 'Testua erabiltzen ari da',
    pt: 'Este teste está em uso'
  },
  DELETE_QUIZ_MODAL_DESCRIPTION: {
    es: 'Este test forma parte de una actividad del curso.<br/> Para poder eliminarlo, primero debes resolver las actividad que lo está usando, ya que no es posible dejar una actividad sin test asociado.',
    en: 'This quiz is part of an activity in the course.<br/> To delete it, you must first resolve the activity that is using it, since it is not possible to leave an activity without a quiz associated.',
    cat: "Aquest test és part d'una activitat del curs.<br/> Per eliminar-lo, primer has de resoldre l'activitat que l'està utilitzant, ja que no és possible deixar una activitat sense un test associat.",
    eus: 'Testua ikastaroko jarduera baten parte da.<br/> Ezabatu nahi duzun jarduera hori ebatzi behar duzu, jarduera hori ezabatu ezin delako.',
    pt: 'Este teste faz parte de uma atividade do curso.<br/> Para eliminá-lo, você deve primeiro resolver a atividade que está usando, pois não é possível deixar uma atividade sem um teste associado.'
  },
  DELETE_QUIZ_MODAL_BUTTON_one: {
    es: 'Eliminar test y actividad',
    en: 'Delete quiz and activity',
    cat: 'Eliminar test i activitat',
    eus: 'Ezabatu testua eta jarduera',
    pt: 'Eliminar teste e atividade'
  },
  DELETE_QUIZ_MODAL_BUTTON_other: {
    es: 'Eliminar test y actividades',
    en: 'Delete quiz and activities',
    cat: 'Eliminar test i activitats',
    eus: 'Ezabatu testua eta jarduerak',
    pt: 'Eliminar teste e atividades'
  },
  DUPLICATE_QUESTIONS_ERROR: {
    es: 'Hay preguntas duplicadas en el test',
    en: 'There are duplicate questions in the quiz',
    cat: 'Hi ha preguntes duplicades al test',
    eus: 'Galdera bikoiztuak daude testan',
    pt: 'Há questões duplicadas no teste'
  },
  DELETE_QUIZ_MODAL_ACTIVITIES_TITLE: {
    es: 'Actividades del curso que usa este test:',
    en: 'Activities of the course that use this quiz:',
    cat: 'Activitats del curs que utilitzen aquest test:',
    eus: 'Ikastaroko jarduerak hori erabiltzen ditu:',
    pt: 'Atividades do curso que usam este teste:'
  },
  TWO_FORMS: {
    es: 'Puedes hacerlo de dos formas:',
    en: 'You can do it in two ways:',
    cat: 'Pots fer-ho de dues maneres:',
    eus: 'Egin de bi modutan:',
    pt: 'Você pode fazer de duas formas:'
  },
  FORM_ONE: {
    es: 'Eliminar la actividad junto con el test.',
    en: 'Delete the activity together with the quiz.',
    cat: "Eliminar l'activitat juntament amb el test.",
    eus: 'Jarduera eta testua baten alde ezabatu.',
    pt: 'Eliminar a atividade junto com o teste.'
  },
  FORM_TWO: {
    es: 'Reemplazar el test dentro de esa actividad. Una vez hecho esto, podrás volver a esta sección y eliminar solo el test.',
    en: 'Replace the quiz within that activity. Once you have done this, you can return to this section and delete only the quiz.',
    cat: "Substitueix el test dins d'aquesta activitat. Una vegada ho hagis fet, pots tornar a aquesta secció i eliminar només el test.",
    eus: 'Testua jarduera horretan ordezkatu. Egin duzunean, izan dezakezu atzera joan eta testua soilik ezabatu.',
    pt: 'Substituir o teste dentro dessa atividade. Uma feito isso, você poderá voltar a esta seção e eliminar apenas o teste.'
  },
  EDITING_BASE_QUIZ_WARNING: {
    es: 'Estás editando un test base. Los cambios que realices se aplicarán a todos los tests sincronizados.',
    en: 'You are editing a base quiz. Changes you make will be applied to all synced quizzes.',
    cat: "Estàs editant un test base. Els canvis que facis s'aplicaran a tots els tests sincronitzats.",
    eus: 'Oinarrizko test bat editatzen ari zara. Egiten dituzun aldaketak sinkronizatutako test guztiei aplikatuko zaizkie.',
    pt: 'Está a editar um teste base. As alterações que fizer serão aplicadas a todos os testes sincronizados.'
  },
  SYNCED_ACTIVITIES_WARNING_one: {
    es: 'Además, hay <strong>{{count}} actividad sincronizada</strong> en otros cursos que también se eliminará.',
    en: 'Additionally, there is <strong>{{count}} synced activity</strong> in other courses that will also be deleted.',
    cat: "A més, hi ha <strong>{{count}} activitat sincronitzada</strong> en altres cursos que també s'eliminarà.",
    eus: 'Gainera, beste ikastaroetan <strong>{{count}} sinkronizatutako jarduera</strong> dago, hori ere ezabatuko da.',
    pt: 'Além disso, há <strong>{{count}} atividade sincronizada</strong> em outros cursos que também será eliminada.'
  },
  SYNCED_ACTIVITIES_WARNING_other: {
    es: 'Además, hay <strong>{{count}} actividades sincronizadas</strong> en otros cursos que también se eliminarán.',
    en: 'Additionally, there are <strong>{{count}} synced activities</strong> in other courses that will also be deleted.',
    cat: "A més, hi ha <strong>{{count}} activitats sincronitzades</strong> en altres cursos que també s'eliminaran.",
    eus: 'Gainera, beste ikastaroetan <strong>{{count}} sinkronizatutako jarduera</strong> daude, hauek ere ezabatuko dira.',
    pt: 'Além disso, há <strong>{{count}} atividades sincronizadas</strong> em outros cursos que também serão eliminadas.'
  }
};
